import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import get from 'lodash/get';
import includes from 'lodash/includes';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import { Router } from '../../src/i18n';
import Layout, { LayoutContent } from '../Layout';
import route from '../../constants/routes';
import { colors } from '../../constants/styleConstants';
import { getFlatFormValues } from '../../utils/formUtils';
import AppCircularProgress from '../AppCircularProgress/AppCircularProgress';
import ImageTag from '../ImageTag';

const ArtistsSearchFilters = dynamic(() => import('../ArtistsSearchFilters'));

const useStyles = makeStyles(theme => ({
  profileHeaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  profileImageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    maxHeight: '360px',
    width: '100%',
    boxShadow: '0 2px 20px 0 rgba(0, 0, 0, 0.1)',
  },
  '@media (max-width: 800px)': {
    profileImageWrapper: {
      maxHeight: '233px',
      boxShadow: 'none',
    },
  },
  layoutClass: {
    padding: '0px !important',
  },
  image: {
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '414px',
    },
    objectFit: 'cover',
  },
  artistSearch: {
    padding: '30px',
    background: colors.background.grayLight,
    [theme.breakpoints.down('xs')]: {
      padding: '15px',
    },
  },
}));

const StubLayout = ({ Content, customBreadcrumbs, title, media, bannerLoading, t, seo }) => {
  const classes = useStyles();
  const router = useRouter();
  const isArtistStubPage = includes(get(router, 'pathname'), '/artists/[id]');

  const searchProfilesWithCriteria = values => {
    const query = getFlatFormValues(values);
    const queryString = get(query, 'query');
    Router.push({
      pathname: route.ARTISTS,
      query: queryString ? { query: queryString } : {},
    });
  };

  const getBannerImage = () => (
    <>
      {bannerLoading ? (
        <AppCircularProgress />
      ) : (
        <>
          <div className={classes.profileHeaderWrapper}>
            {media && (
              <div className={classes.profileImageWrapper}>
                <ImageTag src={media} className={classes.image} alt="banner" placeholder={false} />
              </div>
            )}
          </div>
        </>
      )}
    </>
  );

  const ArtistStubPageSearch = () => (
    <>
      {isArtistStubPage && (
        <div className={classes.artistSearchContainer}>
          <div className={classes.artistSearch}>
            <ArtistsSearchFilters
              fullWidth
              variant="search"
              t={t}
              submitFunc={v => searchProfilesWithCriteria(v)}
              initialValues=""
            />
          </div>
        </div>
      )}
    </>
  );

  return (
    <Layout title={title} customBreadcrumbs={customBreadcrumbs} seo={seo}>
      <LayoutContent className={classes.layoutClass}>
        {bannerLoading ? <AppCircularProgress /> : <ArtistStubPageSearch />}
        {getBannerImage()}
        {Content && <Content />}
      </LayoutContent>
    </Layout>
  );
};

StubLayout.propTypes = {
  title: PropTypes.string.isRequired,
  Content: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  customBreadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  bannerLoading: PropTypes.bool,
  t: PropTypes.func,
  seo: PropTypes.object,
};

export default StubLayout;
